export const environment = {
  apiUrlExbeOn: 'https://localhost:7103/api',
  apiUrlExbeGuardian: 'https://localhost:7055/api',
};
